import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/typography';
import { VerificationErrorContainer } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/docs-verification-steps/verification-error/styles';
import { getImageUrl } from '@utils/get-image-url';

export const VerificationError: FC = () => {
    const { t } = useTranslation();

    return (
        <VerificationErrorContainer>
            <Typography tag='h2' variant='h2' className='title'>
                {t('docVerificationWidget.verificationError.title')}
            </Typography>
            <img
                src={getImageUrl('/images/sdk/verification/no-more-attempts.png')}
                alt='No more attempts'
                className='no-attempts-icon'
            />
            <Typography tag='p' variant='text' className='sub-title' color='text-light'>
                {t('docVerificationWidget.verificationError.subTitle')}
            </Typography>
        </VerificationErrorContainer>
    );
};
